 
import { Button, Col } from "reactstrap";
import { MoreDetails, Unbeatable } from "../../../../../../../constants";
import { useAppDispatch } from "../../../../../../../reduxToolkit/hooks";
import { setMoreDetailsModal } from "../../../../../../../reduxToolkit/reducers/layoutSlice";
import { dynamicImage, Image } from "../../../../../../../utils";
import MoreDetailsModal from "./MoreDetailsModal";

const PropertyCard = () => {
  const dispatch = useAppDispatch();
  return (
    <>
      <Col md="8">
        <div className="white-card property-card">
          <div className="card-title">
            <h5>{Unbeatable}</h5>
            <Button className="btn-solid" onClick={() => dispatch(setMoreDetailsModal())}>
              {MoreDetails}
            </Button>
          </div>
          <Image src={dynamicImage("other/user-dashboard/home-card.png")} alt="home-card" className="img-fluid" />
        </div>
      </Col>
      <MoreDetailsModal />
    </>
  );
};

export default PropertyCard;
